import { render, staticRenderFns } from "./HomePage.vue?vue&type=template&id=89d632f2&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=ts"
export * from "./HomePage.vue?vue&type=script&lang=ts"
import style0 from "./HomePage.vue?vue&type=style&index=0&id=89d632f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89d632f2",
  null
  
)

export default component.exports